import { membersApi, type BranchMember, type MembersFilter } from '../api/member.api';

import type { MembershipItem, MembershipListItem, UserItem } from '@/shared/lib';

export function resolveMembershipBranchIdForMapping(explicit?: number): number | undefined {
  if (explicit !== undefined) {
    if (Number.isFinite(explicit) && explicit > 0) {
      return explicit;
    }
    return undefined;
  }

  if (typeof localStorage !== 'undefined') {
    const n = Number.parseInt(localStorage.getItem('selectedBranchId') || '', 10);
    if (Number.isFinite(n) && n > 0) {
      return n;
    }
  }

  return undefined;
}

function mapBranchMemberToSelectionItem(member: BranchMember, branchId: number): UserItem | null {
  if (member.id == null || member.user?.id == null) {
    return null;
  }

  const { user } = member;
  const positions =
    member.positions?.map((position) => ({
      id: position.id,
      name: position.name,
    })) ?? [];

  const functionalActivities =
    member.functionalActivities?.map((activity) => ({
      functionalActivity: {
        id: activity.id,
        name: activity.name,
      },
    })) ?? [];

  const membership: MembershipItem = {
    id: member.id,
    branchId,
    userId: user.id,
    positions,
    branch: { id: branchId, name: '' },
    functionalActivities,
  };

  const memberships: MembershipListItem[] = [
    {
      ...membership,
      branchName: '',
      positionName: positions[0]?.name ?? '',
      permissions: [],
      createdAt: member.createdAt ?? '',
      updatedAt: member.updatedAt ?? '',
      positionId: positions[0]?.id,
      position: positions[0]
        ? {
            id: positions[0].id,
            name: positions[0].name,
            active: true,
          }
        : undefined,
    },
  ];

  return {
    id: member.id,
    memberId: member.id,
    userId: user.id,
    name: user.name,
    email: user.email,
    registrationNumber: user.registrationNumber ?? null,
    positions,
    membership,
    memberships,
    status: user.status,
    deletedAt: user.deletedAt,
  };
}

export async function fetchAllMembersAsCollaborators(
  membershipBranchId?: number,
  filter?: MembersFilter
): Promise<UserItem[]> {
  const branchId = resolveMembershipBranchIdForMapping(membershipBranchId);
  if (branchId === undefined) {
    return [];
  }

  const combined = await membersApi.getAllMembersPaginated(100, undefined, undefined, filter);
  const collaborators: UserItem[] = [];

  for (const member of combined) {
    const collaborator = mapBranchMemberToSelectionItem(member, branchId);
    if (collaborator) {
      collaborators.push(collaborator);
    }
  }

  return collaborators;
}
